import Vue from 'vue'

import { removeDuplicateTags, removeByKey  } from './helpers/vue_tools.js';

const app = new Vue({
    delimiters: ['${', '}'],
    data:{
        loaded: false,
        totalPagesLoaded: 1,
        totalPages: null,
        headers: {
            totalEntires: null,
            totalQueryPages: null,
        },
        settings:{
            perPage: 100,
            query:{
                postType: 'thesis-projects',
                orderby: 'ASC',
            }
        },
        displayed_data: [],
        entries: [],
        tags: [],
        classes: [],

        count_tags_selected: 0,
        count_class_years_selected: 0,

    },
    mounted: function(){
        const t = this;
        t.$data.url = window.location.href;

        // Query for Terms
        t.queryTags({});
        t.queryYears({});
    },
    methods:{
        queryTags: function( params ){
            const t = this;

            let fetchURL = "/wp-json/wp/v2/post_tags?per_page=100";

            fetch( fetchURL ).then(function (response) {
                if(response.ok){
                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                for (var i = data.length - 1; i >= 0; i--) {
                    t.$data.tags.push({
                        id: parseInt(data[i].id),
                        name: data[i].name,
                        checked: false
                    });
                };

                t.$data.tags.sort( (a, b) =>{
                    return t.sortByName(a,b);
                });

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        queryYears: function( params ){
            const t = this;

            let fetchURL = "/wp-json/wp/v2/classes?per_page=100";

            fetch( fetchURL ).then(function (response) {
                if(response.ok){
                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {

                for (var i = data.length - 1; i >= 0; i--) {
                    t.$data.classes.push({
                        id: parseInt(data[i].id),
                        name: data[i].name,
                        checked: false
                    });
                };

                t.$data.classes.sort( (a,b) =>{
                    return t.sortByName(a,b);
                });

                // Query for Data
                t.queryAPI({});

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        queryAPI: function( params ){
            const t = this;

            let fetchURL = '/wp-json/wp/v2/'+t.$data.settings.query.postType+'/';
                fetchURL += '?per_page='+t.$data.settings.perPage+'&page=' + t.$data.totalPagesLoaded;
                fetchURL += '&custom_order_by=' + t.$data.settings.query.orderby;

            fetch( fetchURL ).then(function (response) {
                if(response.ok){

                    response.headers.forEach( function(element, index) {
                        if(index==='x-wp-total'){
                            t.$data.headers.totalEntires = parseInt(element);
                        }

                        if(index==='x-wp-totalpages'){
                            t.$data.headers.totalQueryPages = parseInt(element);
                        }
                    });

                    return response.json();
                }
                else{
                    return Promise.reject(response);
                }
            }).then(function (data) {
                    t.$data.totalPages = t.$data.headers.totalEntires / t.$data.settings.perPage;
                    t.parseData( data );

                    if (t.$data.totalPagesLoaded < t.$data.headers.totalQueryPages) {
                        t.loadMore();
                    }
                    else{
                        t.$data.loaded = true;
                    }

            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            });
        },

        parseData: function( data ){

            const t = this;

            if(data.length ){
                for(let i = 0, length1 = data.length; i < length1; i++){

                    let simpleTags = [];
                    let simpleClassYears = [];

                    for (var j = data[i].post_tags.length - 1; j >= 0; j--) {
                        simpleTags.push( data[i].post_tags[j].term_id );
                    };

                    for (var j = data[i].classes.length - 1; j >= 0; j--) {
                        simpleClassYears.push( data[i].classes[j].term_id );
                    };

                    // console.log( data[i].classes.length, data[i].classes[0] );
                    let aria_label_author = '';

                    if (data[i].acf.project_author.post_title !== undefined) {
                        aria_label_author = ' by ' + data[i].acf.project_author.post_title;
                    }

                    let entryData = {
                        index: i,
                        id: data[i].id,
                        slug: data[i].slug,
                        title: data[i].title.rendered,
                        aria_label: data[i].title.rendered + aria_label_author,
                        trunceated_title: data[i].title.rendered.slice(0,100)+'&hellip;',
                        url: data[i].link,
                        filters:{
                            tags: simpleTags,
                            class_years: simpleClassYears,
                        },
                        post_date: data[i].date,
                        author_class: (data[i].classes.length !== 0 ) ?  data[i].classes[0].name : '',
                        excerpt: data[i].acf.project_synopsis_expert,


                        trunceated_excerpt: data[i].acf.project_synopsis_expert.slice(0,150)+'&hellip;',
                        trunceated_author_class: (data[i].classes.length !== 0 ) ?  "&#8219;"+data[i].classes[0].name.slice(2,4) : '',

                        acf: data[i].acf,

                        featured_image: data[i].featured_media,
                    };

                    //

                    t.$data.entries.push( entryData );
                };

                t.$data.displayed_data = t.$data.entries.sort( (a,b) =>{
                    return t.sortByAuthorClassYear(a,b);
                });

                let filters = t.fetchPassedFilters();
                t.setPassedFilterValues( filters );

                t.updateResults( filters );
            }
        },

        applyFilters: function( $event ){
            $event.preventDefault();

            console.log('CLICK: Apply Filters');

            const t = this;

            let filters = t.fetchPassedFilters();
            t.setPassedFilterValues( filters );

            t.updateResults( filters );

            t.closeDropdownMenus();
        },

        closeDropdownMenus: function(){
            let btns = document.getElementsByClassName('ariamenu-open');

            console.log('Close Dropdown Menus', btns.length);

            for (var i = btns.length - 1; i >= 0; i--) {
                let btn = btns[i];
                btn.click();
            };
        },

        setPassedFilterValues: function( filters ){
            /*  == setPassedFilterValues ==
                Accept an param that contains the values of the POST request.
                Loops through the tags and classes and marks those
                passed variables as true.
            */
            const t = this;
            let tagCount = 0;
            let classYearCount = 0;

            console.log('\nSet Passed Filter Values: ', filters);

            for (var i = t.$data.tags.length - 1; i >= 0; i--) {
                let isIncluded = filters.tags.includes( t.$data.tags[i].id.toString() );

                t.$data.tags[i].checked = isIncluded;

                if(isIncluded){
                    tagCount++;
                }
            };


            for (var i = t.$data.classes.length - 1; i >= 0; i--) {
                let isIncluded = filters.class_years.includes( t.$data.classes[i].id.toString() );
                t.$data.classes[i].checked = isIncluded;

                if(isIncluded){
                    classYearCount++;
                }
            };

            t.$data.count_tags_selected = tagCount;
            t.$data.count_class_years_selected = classYearCount;
        },

        fetchPassedFilters: function(){
            /*  == fetchPassedFilters ==
                This looks for the hidden input fields on the page that contain POST variables
                that contains ID passed from a form on the thesis page. These values are parsed
                and send back as an array.
            */
            const t = this;

            let tagsSelected = document.querySelector('input[name="selected-tags-selector"]');
            let yearsSelected = document.querySelector('input[name="selected-years-selector"]');

            let filterValues = {
                tags: tagsSelected.value.split(',').filter(Number),
                class_years: yearsSelected.value.split(',').filter(Number)
            };

            return filterValues;
        },

        clearAll: function( $event ){
            /*  == clearAll ==
                Sets the hidden inputs to no value.
                Loops through tags and class and set all checked values to false
                Reset counts to 0.
            */
            $event.preventDefault();
            const t = this;

            let tagsSelected = document.querySelector('input[name="selected-tags-selector"]');
            let yearsSelected = document.querySelector('input[name="selected-years-selector"]');

            for (var i = t.$data.tags.length - 1; i >= 0; i--) {
                t.$data.tags[i].checked = false;
            };


            for (var i = t.$data.classes.length - 1; i >= 0; i--) {
                t.$data.classes[i].checked = false;
            };

            tagsSelected.value = "";
            yearsSelected.value = "";


            t.$data.count_tags_selected = 0;
            t.$data.count_class_years_selected = 0;

            t.$data.displayed_data = t.$data.entries.sort( (a,b) =>{
                    return t.sortByAuthorClassYear(a,b);
                });

            t.closeDropdownMenus();
        },

        clearButton: function($event, type, id){
            $event.preventDefault();
            const t = this;
            let input = "";
            id = id.toString();

            if (type == "class_year") {
                input = document.querySelector('input[name="selected-years-selector"]');
            }
            else if(type == "tag"){
                input = document.querySelector('input[name="selected-tags-selector"]');
            }

            let inputValues = input.value.split(',').filter(Number);
            let isIncluded = inputValues.includes( id );

            if(isIncluded){
                inputValues.splice( inputValues.indexOf( id ), 1 )
                input.value = inputValues.join(',');

                t.applyFilters( $event );
                t.closeDropdownMenus();
            }
        },


        updateResults: function( filters ){
            console.log('Update Results w/ Filters: ', filters );

            const t = this;
            let updatedResults = [];

            for (var i =  t.$data.entries.length - 1; i >= 0; i--) {
                /*
                If this post has been tagged with a TAG, loop though the posts TAGS to see if any of the IDs match the currently selected filtrs. If so, add it to our temporary results.
                */

                if(filters.tags.length > 0 && filters.class_years.length > 0){
                    // console.log('Filter Tags AND Years');
                    let tmpStorage = null;
                    let add = 0;

                    for (var j = t.$data.entries[i].filters.tags.length - 1; j >= 0; j--) {
                        if( filters.tags.includes( t.$data.entries[i].filters.tags[j].toString() ) ){
                            tmpStorage = t.$data.entries[i];
                            add++;
                        }
                    };

                    for (var j = t.$data.entries[i].filters.class_years.length - 1; j >= 0; j--) {
                        if( filters.class_years.includes( t.$data.entries[i].filters.class_years[j].toString() ) ){
                            tmpStorage = t.$data.entries[i];
                            add++;
                        }
                    };

                    // Add to results only if both params are meet.
                    if(add == 2) updatedResults.push( tmpStorage );
                }
                else if(filters.tags.length > 0){
                    // console.log('Filter Just Tags');
                    for (var j = t.$data.entries[i].filters.tags.length - 1; j >= 0; j--) {
                        if( filters.tags.includes( t.$data.entries[i].filters.tags[j].toString() ) ){
                            updatedResults.push( t.$data.entries[i] );
                        }
                    };
                }
                else if(filters.class_years.length > 0){
                    // console.log('Filter Just Years');
                    for (var j = t.$data.entries[i].filters.class_years.length - 1; j >= 0; j--) {
                        if( filters.class_years.includes( t.$data.entries[i].filters.class_years[j].toString() ) ){
                            updatedResults.push( t.$data.entries[i] );
                        }
                    };
                }
                else{
                    updatedResults = t.$data.entries;
                }

            };

            // console.log('Updated Final Results: ', updatedResults );
            if(updatedResults){
                t.$data.displayed_data = updatedResults.sort( (a,b) =>{
                    return t.sortByAuthorClassYear(a,b);
                });
            }
        },

        sortByName: function(a, b){
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }

            return 0;
        },

        sortByAuthorClassYear: function(a, b){
            if (parseInt(a.author_class) > parseInt(b.author_class)) {
                return -1;
            }
            if (parseInt(a.author_class) < parseInt(b.author_class)) {
                return 1;
            }

            return 0;
        },

        getSrcSet: function( obj ) {
            let scrset_string = '';

            if(obj.sizes.headshot_large) scrset_string += obj.base_path+obj.sizes.headshot_large.file+' 1x';

            if(obj.sizes.headshot_large_xhidpi) scrset_string += ', ' + obj.base_path+obj.sizes.headshot_large_xhidpi.file+' 2x';

            if(obj.full_path) scrset_string += ', ' + obj.full_path+' 3x';

            return scrset_string;
        },
        loadMore: function( $event ){
            const t = this;

            t.$data.totalPagesLoaded++;
            t.queryAPI({});
        }
    }
}).$mount('#thesis-browser')
